import type { PropType } from 'virtual-vue';
import type { TabBarItemProps, TabBarProps } from './tab-bar';

export const tabBarProps = {
  /** 当前选中标签的索引 - 仅vue2可用 */
  value: {
    type: [String, Number] as PropType<TabBarProps['value']>,
    default: '' as TabBarProps['value'],
  },
  /** 当前选中标签的索引 - 仅vue3可用 */
  modelValue: {
    type: [String, Number] as PropType<TabBarProps['modelValue']>,
    default: '' as TabBarProps['modelValue'],
  },
};

export const tabBarItemProps = {
  /** 徽标提示信息 */
  badge: {
    type: Object as PropType<TabBarItemProps['badge']>,
    default: (): TabBarItemProps['badge'] => undefined,
  },
  /** 标签的索引 */
  index: {
    type: [String, Number] as PropType<TabBarItemProps['index']>,
    require: true,
    default: '',
  },
  /** 激活与未激活图标 */
  icons: {
    type: Object as PropType<TabBarItemProps['icons']>,
    require: true,
    default: () => {},
  },
};
